import { refreshTokenHandler, setLocaleHeader } from '@brightdrop/auth-client';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const ordertrackingInitialApi = createApi({
  reducerPath: 'rtkOrdertrackingClient',
  refetchOnMountOrArgChange: 10,
  baseQuery: fetchBaseQuery({
    baseUrl: `${globalThis.appConfig.apiBaseUrl}/ordertracking`,
    prepareHeaders: async (headers) => {
      const response = await refreshTokenHandler();
      const { accessToken: token } = response ?? {};

      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      if (!headers.has('Accept')) {
        headers.set('Accept', 'application/json, text/plain, */*');
      }
      if (!headers.has('content-type')) {
        headers.set('Content-Type', 'application/json');
      }
      setLocaleHeader(headers);

      return headers;
    },
  }),
  endpoints: () => ({}),
});
